import makeVariant from '../makeVariant';

/**
 * Gets the Header's background appearance.
 * @param {String} variant The Header's background style.
 */
export const getHeaderAppearance = makeVariant(
  {},
  {
    default: {
      backgroundColor: 'background',
    },

    transparent: {
      backgroundColor: ['white', 'white', 'white', 'transparent'],
      color: ['text', 'text', 'text', 'white'],
      '&&& a': { color: ['text', 'text', 'text', 'white'] },
      '> a': { color: ['text', 'text', 'text', 'white'] },
    },
  }
);

/**
 * Gets the Header's attachment.
 * @param {'default' | 'fixed'} variant The Header's background style.
 */
export const getHeaderAttachment = makeVariant(
  {},
  {
    default: {},

    fixed: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 2,
    },

    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 2,
    },
  }
);

export const Header = {
  boxShadow: 'large',
};

export const Brand = {
  marginTop: 3,
  marginBottom: 2,
  paddingY: 2,
};

export const Nav = {
  ml: 'auto',
  paddingTop: 2,
};

export const NavbarContainer = {};

export const NavLeft = {
  ml: 0,
  mr: 'auto',
};

export const NavLink = {
  textTransform: 'uppercase',
  borderBottom: '4px solid transparent',
  paddingTop: 4,
  fontWeight: 300,

  '[aria-current]:not(false)': {
    textTransform: 'underline',
  },

  ':hover': {
    borderColor: 'primary',
  },

  //Hack to increase specificity (`&&&` repeats the className three times).
  '&&&': {
    color: 'text',
    // Add horizontal padding to the items.
    paddingX: [null, null, 3],
    ':hover': {
      color: 'primary',
    },
  },

  a: { color: '#01afee !important' },
};

export const NavItem = {};

export const NavDropdown = {
  // Style the NavDropdown inner link like the NavLink.
  '> a': NavLink,
};

export const NavigationCollapse = {};

export const NavDropdownItem = {
  '&&&&': { color: 'text' },
};

export const NavbarToggle = {
  alignSelf: 'center',
  border: 0,
};
